<div class="card">
    <h1 class="text-center">THIS IS A TEST PAGE</h1>
    <h2 class="text-center">Only for Developers 😎</h2>

    <app-dynamic-form #myForm [fields]="formConfig" (onNoSubmitClick)="action($event)"
        (onFieldChangeEmitter)="onFormChanges($event)">
    </app-dynamic-form>

</div>

<div class="card flex items-center justify-center">

    <button (click)="flick()" class="p-4 bg-primary-50 rounded-2xl">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round"
            class="icon icon-tabler icons-tabler-outline icon-tabler-hand-click w-8 h-8">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5" />
            <path d="M11 11.5v-2a1.5 1.5 0 0 1 3 0v2.5" />
            <path d="M14 10.5a1.5 1.5 0 0 1 3 0v1.5" />
            <path
                d="M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47" />
            <path d="M5 3l-1 -1" />
            <path d="M4 7h-1" />
            <path d="M14 3l1 -1" />
            <path d="M15 6h1" />
        </svg>
    </button>

</div>

<div class="p-4 rounded-2xl bg-white/5 m-4">
    <button (click)="yap()" class="p-4 bg-primary-50 rounded-2xl">
        YAPPER
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round"
            class="icon icon-tabler icons-tabler-outline icon-tabler-hand-click w-8 h-8">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5" />
            <path d="M11 11.5v-2a1.5 1.5 0 0 1 3 0v2.5" />
            <path d="M14 10.5a1.5 1.5 0 0 1 3 0v1.5" />
            <path
                d="M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47" />
            <path d="M5 3l-1 -1" />
            <path d="M4 7h-1" />
            <path d="M14 3l1 -1" />
            <path d="M15 6h1" />
        </svg>
    </button>
    <!--<app-custom-grid #cgrid [tableOptions]="tableOptions" [gridColConfig]="gridOptions" [pageSettings]="pageSettings"
        [paging]="true" [template]="tryTest">
        <ng-template #tryTest>
            <ejs-tooltip id="newTool" target="#newUser" content="Aggiungi un nuovo cliente">
                <button ejs-button id="newUser" class="e-flat e-flat-add ml-3"><i class="e-icons e-add"></i></button>
            </ejs-tooltip>
        </ng-template>
    </app-custom-grid>-->
</div>